import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import { HelmetProvider } from 'react-helmet-async';
import HeadMeta from './components/HeadMeta';
import Dashboard from './pages/Dashboard'; 
import Users from './pages/users';
import UserInfo from './pages/userInfo';
import TrxsAll from './pages/TrxsAll';
import ExchangeDayList from './pages/exchangeDayList';
import ReportPartner from './pages/ReportPartner';
import Vendors from './pages/Vendors';
import DailyAD from './pages/DailyAD';
import DailyAM from './pages/DailyAM';
import LogsSend from './pages/LogsSend'; 
import LimitChangeLogs from './pages/LimitChangeLogs'; 
import Gamelimit from './pages/Gamelimit'; 
import GameLimitList from './pages/GameLimitList'; 
import LoginLog from './pages/loginLog';
import Notice from './pages/Notice';
import TransferLog from './pages/TransferLog';
import Agents from './pages/Agents';
import AgentsReg from './pages/AgentsReg';
import AgentsInfo from './pages/agentInfo';
import ApiDoc from './pages/ApiDoc';
import ApiCommon from './pages/ApiCommon';
import NewGame from './pages/NewGame';
import NoKor from './pages/NoKor';
import MyMoney from './pages/MyMoney';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));

  useEffect(() => {
    const handleStorage = () => {
      setIsLoggedIn(!!localStorage.getItem('token'));
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return (
    <HelmetProvider>
      <HeadMeta />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          {isLoggedIn ? (
          <Route path="/" element={<Layout setIsLoggedIn={setIsLoggedIn} />}>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="userInfo" element={<UserInfo />} />
            <Route path="TrxsAll" element={<TrxsAll />} />
            <Route path="exchangeDayList" element={<ExchangeDayList />} />
            <Route path="ReportPartner" element={<ReportPartner />} />
            <Route path="Vendors" element={<Vendors />} />
            <Route path="DailyAD" element={<DailyAD />} />
            <Route path="DailyAM" element={<DailyAM />} />
            <Route path="LogsSend" element={<LogsSend />} />
            <Route path="LimitChangeLogs" element={<LimitChangeLogs />} />
            <Route path="loginLog" element={<LoginLog />} />
            <Route path="Gamelimit" element={<Gamelimit />} />
            <Route path="GameLimitList" element={<GameLimitList />} />
            <Route path="Notice" element={<Notice noticeType="notice" />} />
            <Route path="NoticeUpdate" element={<Notice noticeType="updateInfo" />} />
            <Route path="TransferOther" element={<TransferLog TransType="other" />} />
            <Route path="MyMoney" element={<MyMoney />} />
            <Route path="Agents" element={<Agents />} />
            <Route path="AgentsReg" element={<AgentsReg />} />
            <Route path="agentInfo" element={<AgentsInfo />} />
            <Route path="ApiDoc" element={<ApiDoc />} />
            <Route path="ApiCommon" element={<ApiCommon />} />
            <Route path="NewGame" element={<NewGame />} />
            <Route path="NoKor" element={<NoKor />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
